export interface IWidgetStyling {
  popupBorderRadiusPx?: number | null;
  popupPaddingPx?: number | null;
  popupMaxWidthPx?: number | null;
  popupFontSizePx?: number | null;
  closeButtonBorderRadiusPx?: number | null;
  closeButtonSizePx?: number | null;
  launcherBorderRadiusPx?: number | null;
}

export const WIDGET_STYLING_FIELDS: ReadonlyArray<{
  key: keyof IWidgetStyling; label: string; min: number; max: number; hint: string;
}> = [
  {key: 'popupBorderRadiusPx', label: 'Pop-up corner radius', min: 0, max: 128, hint: '0 gives square corners. Hide the speech-bubble tail for a rectangular pop-up.'},
  {key: 'closeButtonBorderRadiusPx', label: 'Close button corner radius', min: 0, max: 32, hint: '0 gives a square close button. Empty keeps the circular default.'},
  {key: 'launcherBorderRadiusPx', label: 'Launcher corner radius', min: 0, max: 256, hint: 'Applies to framed artwork. Image-only launchers keep the original artwork.'},
  {key: 'popupPaddingPx', label: 'Pop-up padding', min: 0, max: 48, hint: 'Space around the pop-up content.'},
  {key: 'popupMaxWidthPx', label: 'Pop-up maximum width', min: 160, max: 640, hint: 'Limited to the available screen width.'},
  {key: 'popupFontSizePx', label: 'Pop-up text size', min: 10, max: 32, hint: 'Text size inside the teaser bubble.'},
  {key: 'closeButtonSizePx', label: 'Close button size', min: 32, max: 64, hint: 'Width and height of the close button.'},
];
